import React from "react";
import { Route, Navigate } from "react-router-dom";

const PrivateRoute = ({ element: Component, ...rest }) => {
  const isAuthenticated = !!localStorage.getItem("authToken");

  return isAuthenticated ? <Component {...rest} /> : <Navigate to="/signin" />;
};

export default PrivateRoute;
